import React from 'react'
import PropTypes from 'prop-types'
import FooterLinkList from './FooterLinkList'
import FooterText from './FooterText'

const FooterColumn = ({
  items,
  isNested = false,
  itemKey = 'columncontrol',
  version
}) => {
  if (!items) return
  const columns = Object.keys(items[itemKey].items).filter(
    columnName => columnName !== 'columns'
  )

  return items[itemKey].columnList.map((column, columnIndex) => {
    return (
      <div
        className={`${column.columnClass} ${isNested ? 'col-nested' : ''}`}
        key={columnIndex}
      >
        {columns.length > 0 &&
          items[itemKey].items[columns[columnIndex]][':itemsOrder'].map(
            (c, index) => {
              const item =
                items[itemKey].items[columns[columnIndex]][':items'][c]
              return (
                <div key={index}>
                  {item.text && (
                    <FooterText text={item.text} version={version} />
                  )}
                  {item.columnList && (
                    <div className={itemKey}>
                      <FooterColumn
                        items={{ columncontrol: item }}
                        isNested={true}
                        key="columncontrol"
                        version={version}
                      />
                    </div>
                  )}
                  {item.links && (
                    <FooterLinkList
                      links={item.links}
                      item={item}
                      isNested={isNested}
                      version={version}
                    />
                  )}
                </div>
              )
            }
          )}
      </div>
    )
  })
}

FooterColumn.propTypes = {
  items: PropTypes.object.isRequired,
  itemKey: PropTypes.string,
  isNested: PropTypes.bool,
  version: PropTypes.string
}

export default FooterColumn



// WEBPACK FOOTER //
// ./src/components/Footer/FooterColumn.js